@if (tags$ | async; as tags) {
  <div
    class="tags"
    [attr.data-testid]="'tag-tree-picker-container'"
    >
    @for (tag of tags; track tag) {
      <div
        class="tag"
        [style.background-color]="tag.color || 'rgba(255, 255, 255, 0.3)'"
        (contextmenu)="selected = tag"
        [matContextMenu]="tagContextMenu"
        [attr.data-testid]="'tag-item-' + tag.id"
        >
        <span [attr.data-testid]="'tag-name'">{{ tag.name }}</span>
        <mat-icon
          class="close"
          (click)="delete(tag)"
          matTooltip="刪除"
          i18n-matTooltip="刪除"
          [attr.data-testid]="'delete-tag-button'"
          >close</mat-icon
          >
        </div>
      }
      <button
        mat-button
        #addTagButton
        type="button"
        class="tag add"
        (click)="addTag(addTagButton)"
        [attr.data-testid]="'add-tag-button'"
        >
        <mat-icon [attr.data-testid]="'add-tag-icon'">add</mat-icon>
        <span [attr.data-testid]="'add-tag-title'">{{ title }}</span>
      </button>
    </div>
  }

  <mat-menu
    #tagContextMenu="matMenu"
    class="tiny-menu"
    [attr.data-testid]="'tag-context-menu'"
    >
    <button
      mat-menu-item
      (click)="delete(selected)"
      i18n
      [attr.data-testid]="'delete-tag-menu-item'"
      >
    刪除
  </button>
  </mat-menu>
